
import { defineStore } from "pinia";
import {reactive, ref, watch} from "vue";

const STORAGE_KEY = "vehicleregistration-list-state";
const ALLOWED_PAGE_SIZES = [10, 25, 50, 100];

interface SavedState {
  filter?: { number?: string, kennzeichen?: string, FIN?: string }
  filter2?: { imBestand?: string, ignorierte?: string, vorschlag?: string }
  pageSize?: number
  currentPage?: number
}

/** Gespeicherten Zustand lesen; localStorage kann fehlen oder leer sein (privates Fenster, gesperrt). */
function loadState(): SavedState {
  try {
    const t_raw = window.localStorage.getItem(STORAGE_KEY)
    return t_raw ? JSON.parse(t_raw) as SavedState : {}
  } catch {
    return {}
  }
}

function saveState(state: SavedState) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
  } catch {
    // nicht speicherbar: die Liste funktioniert trotzdem, nur ohne Merken über das Neuladen hinaus
  }
}

export const useVehicleRegistrationStore = defineStore("vr", () => {

        const saved = loadState()

        const vehicleRegistrationId = ref<string | undefined>(undefined);

        const listPageFilter2 = reactive({  imBestand: "all", ignorierte: "all", vorschlag: "all", ...saved.filter2})
        const listPageFilter = reactive({ number : "", kennzeichen : "", FIN:"", ...saved.filter})
        /** Seitengröße und aktuelle Seite des Grids in der Zulassungsliste */
        const listPageSettings = reactive({
          pageSize: ALLOWED_PAGE_SIZES.includes(saved.pageSize ?? 0) ? saved.pageSize as number : 50,
          currentPage: saved.currentPage && saved.currentPage > 0 ? saved.currentPage : 1
        })

        watch([listPageFilter, listPageFilter2, listPageSettings], () => {
          saveState({
            filter: {...listPageFilter},
            filter2: {...listPageFilter2},
            pageSize: listPageSettings.pageSize,
            currentPage: listPageSettings.currentPage
          })
        }, {deep: true})

        return {vehicleRegistrationId,listPageFilter2: listPageFilter2,listPageFilter, listPageSettings};
});
